$(document).on('turbolinks:load', function(){
    $("#agreements").click(function() {
        if($('#agreements').is(':checked')){
            $("#confirm-btn").prop("disabled",false);
        }else{
            $("#confirm-btn").prop("disabled",true);
        }
    });
});